<span class="add-container">
  <app-button
    (click)="csvExportMaintenance()"
    [black]="true"
    [title]="'resources.export_maintenance_logs' | translate"
    class="btn-margin"
    header-button
    [disabled]="!this.maintenanceLogs || this.maintenanceLogs.length === 0"
  >
  </app-button>
</span>

<qs-table
  testId="maintenance-logbook-table"
  [rowTestIdFn]="maintenanceRowTestId"
  [data]="maintenanceLogs"
  [columns]="columns"
  [expandable]="true"
  [columnFilterConfig]="columnFilterConfig"
  [detailTemplate]="myDetailTemplate"
  [isPaginatorEnabled]="true"
>
</qs-table>

<ng-template #myDetailTemplate let-row>
  <div class="element-detail">
    <div class="expanded-detail">
      <div>{{ 'drone.maintenance_logbook.comment' | translate }}</div>
      <div>{{ 'drone.maintenance_logbook.attachments' | translate }}</div>
      <div>{{ row.detailedDescription }}</div>
      <div class="attachments">
        @for (attachment of row.attachments; track attachment) {
          <div class="attachment">
            <img class="icon-upload" src="../../../assets/svg/attachment.svg" />
            <span>{{ attachment }}</span>
          </div>
        }
      </div>
    </div>
  </div>
</ng-template>
